import { NgModule } from "@angular/core";
import { AmountSelectorComponent } from "@modules/staking/components/amount-selector/amount-selector.component";
import { StakingPreScreenComponent } from "@modules/staking/components/pre-screen/pre-screen.component";
import { SummaryComponent } from "@modules/staking/components/summary/summary.component";
import { SuccessScreenComponent } from "@modules/staking/components/success-screen/success-screen.component";
import { PendingScreenComponent } from "@modules/staking/components/pending-screen/pending-screen.component";
import { StakeableListItemComponent } from "@modules/staking/components/stakeable-list-item/stakeable-list-item.component";
import { StakeableSelectorComponent } from "@modules/staking/containers/stakeable-selector/stakeable-selector.component";
import { TradableToViewModule } from "@modules/main/components/tradable-to-view-item/tradable-to-view.module";
import {
	StakingAmountSelectorStateTypePipe,
	StakingAmountSelectorAvailableToStakePipe
} from "../domain/pipes/stake-amount-selector.pipes";
import { StakingUtlityModule } from "@modules/staking/tests/staking-utlity.module";
import { A11yModule } from "@angular/cdk/a11y";
import { StakingSoldOutComponent } from "@modules/staking/components/staking-sold-out/staking-sold-out.component";
import { LockedStakingDisclaimerComponent } from "@modules/staking/components/locked-staking-disclaimer/locked-staking-disclaimer.component";
import { LockedStakingFinalReminderComponent } from "@modules/staking/components/locked-staking-final-reminder/locked-staking-final-reminder.component";
import { BpBadgeModule } from "@modules/shared/bp-badge/bp-badge.module";
import { LockedStakingUnstakeDisclaimerComponent } from "@modules/staking/components/locked-staking-unstake-disclaimer/locked-staking-unstake-disclaimer.component";
import { UnstakingCountdownItemComponent } from "@modules/staking/components/unstaking-countdown-item/unstaking-countdown-item.component";
import { TermsAndConditionsUpdatesModule } from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.module";
import { UKFinPromModule } from "@modules/uk-finprom/ukfinprom.module";

const components = [
	StakingPreScreenComponent,
	StakeableSelectorComponent,
	StakeableListItemComponent,
	AmountSelectorComponent,
	SummaryComponent,
	SuccessScreenComponent,
	PendingScreenComponent,
	StakingSoldOutComponent,
	LockedStakingDisclaimerComponent,
	LockedStakingFinalReminderComponent,
	LockedStakingUnstakeDisclaimerComponent,
	UnstakingCountdownItemComponent
];

const pipes = [StakingAmountSelectorStateTypePipe, StakingAmountSelectorAvailableToStakePipe];

@NgModule({
	imports: [
		TradableToViewModule,
		StakingUtlityModule,
		A11yModule,
		BpBadgeModule,
		TermsAndConditionsUpdatesModule,
		UKFinPromModule
	],
	declarations: [...components, ...pipes],
	exports: [...components, ...pipes, StakingUtlityModule, A11yModule]
})
export class StakingSharedModule {}
